// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1-Igp","containerItemsCenter":"Skeleton_containerItemsCenter__1NdJy"};